var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelivered(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64427 10.7085L6.39062 7.45486C5.6105 6.67474 4.34568 6.67474 3.56569 7.45486L0.914679 10.1059C0.13456 10.886 0.13456 12.1508 0.914679 12.9308L7.46209 19.4782L8.17137 19.9076L11.1924 19.787L25.3943 5.47264L23.8334 2.62498L20.676 1.40967L20.2015 1.76437L11.2574 10.7084C10.8118 11.1539 10.0897 11.1539 9.64427 10.7085Z",
    fill: "#EAF6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0852 3.61664L23.6299 1.16126C22.8497 0.381142 21.5849 0.381142 20.8049 1.16126L20.2016 1.76454C20.7808 1.70335 21.3814 1.89377 21.8254 2.3376L23.0936 3.61664C23.8737 4.39676 23.8737 5.66158 23.0936 6.44157L11.0083 18.5632C10.0482 19.5233 8.68114 19.828 7.4624 19.4783L7.70691 19.7228C9.11455 21.1304 11.3966 21.1304 12.8043 19.7228L26.0854 6.4417C26.8653 5.66158 26.8653 4.39676 26.0852 3.61664Z",
    fill: "#C8EFFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/Delivered.68dd8946a5fb98a92b14825d5ffb5f22.svg";
export { ForwardRef as ReactComponent };